<template>
  <module-page v-bind="pageParams" :customBreadcrumbs="customBreadcrumbs">
    <Modal
      v-if="showTechnicalAssistanceServiceActions"
      :message="$t('pages.support.technicalAssistance.modalTitle')"
      :messageInformation="technicalAssistanceTerms"
    ></Modal>
    <v-layout v-if="!loading" row wrap>
      <v-flex xs12 md8 lg8>
        <v-tabs class="page__tabs" hide-slider>
          <v-tab
            v-for="(tab, i) in pageParams.tabs"
            @click="goToTab(tab.value)"
            :key="i"
            active-class="support--background white--text"
          >
            {{
              tab.title.mobile
                ? mobile
                  ? tab.title.mobile
                  : tab.title.notMobile
                : tab.title
            }}
          </v-tab>
        </v-tabs>
        <v-form
          v-if="!newTicketNumber"
          v-model="formValid"
          @submit.prevent="submit"
          ref="supportForm"
          lazy-validation
          class="pr-3"
        >
          <v-card class="mt-2 mb-5">
            <v-card-title class="pt-headline support--color pb-1">{{
              $t('pages.support.ticketForm.title')
            }}</v-card-title>
            <v-card-text class="pt-1">
              <v-layout row wrap>
                <v-flex
                  xs12
                  sm5
                  md6
                  lg6
                  xl4
                  v-if="
                    technicalAssistanceStep !==
                    TECHNICAL_ASSISTANCE_STEPS.CONCLUDED
                  "
                >
                  <v-select
                    v-model="selectedSummary"
                    class="select-field2 --required"
                    :label="$t('pages.support.subjectInput')"
                    :rules="rule.required"
                    :items="ticketSubjects"
                    :menu-props="{
                      overflowY: true,
                      bottom: true,
                    }"
                    color="#999999"
                    append-icon="bexsicon-menu-down"
                    return-object
                    outline
                    required
                  >
                  </v-select>
                </v-flex>
                <TechnicalAssistance
                  v-if="showTechnicalAssistanceServiceActions"
                  :currentStep="technicalAssistanceStep"
                  :solicitationCallback="getSelectedReasons"
                  :selectedItems="selectedReasons"
                  :scheduleCallback="setSchedule"
                  :concludedDate="concluded"
                  :reasonTicketInfo="reasonTicket"
                  :reasons="reasons"
                  :technicalSchedule="technicalSchedule"
                  :technicalDate="technicalDate"
                  :previousReasons="previousReasons"
                />

                <template
                  v-if="
                    !showTechnicalAssistanceServiceActions ||
                    technicalAssistanceStep === TECHNICAL_ASSISTANCE_STEPS.FORM
                  "
                >
                  <v-flex xs12>
                    <label required class="v-label --required__label">{{
                      $t('pages.support.messageInput')
                    }}</label>
                    <div
                      class="ticket__input"
                      :class="{ ticket__input__error: !formValid }"
                    >
                      <v-textarea
                        required
                        auto-grow
                        solo
                        style="white-space: pre"
                        v-model="model.public.content"
                        :rules="rule.required"
                      ></v-textarea>
                      <file-input
                        @input="updateFiles"
                        @fileToLarge="handleFileToLarge"
                        @fileInvalid="handleFileInvalid"
                        :maxFileSize="maxFileSize"
                        :label="$t('labels.fileInput.title')"
                        :btn-label="$t('labels.fileInput.selectBtn')"
                        :drag-and-drop-label="
                          $t('labels.fileInput.dragAndDropAction')
                        "
                        class="ticket__file-input"
                        btn-class="support--background white--text btn-md"
                        drag-and-drop-class="support--color btn-md"
                        append-icon="attachment"
                        loadColor="blue"
                      ></file-input>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <span class="error--text">{{ fileError }}</span>
                    <file-preview
                      show-remove
                      :items="files"
                      btn-classes="support--background white--text btn-md"
                      @remove="removeFile"
                    ></file-preview>
                  </v-flex>
                </template>
              </v-layout>
            </v-card-text>
            <Warning
              v-if="showWarrantyWarning"
              :message="$t('responses.solicitationOutWarranty')"
              :messageLink="documentResponsible.title"
              :linkPath="documentResponsible.attachment"
            >
              <template
                slot="link"
                slot-scope="{ message, messageLink, linkPath }"
              >
                <form
                  name="ownerDocument"
                  method="POST"
                  :action="linkPath"
                  target="_blank"
                >
                  <input
                    type="hidden"
                    name="idemp"
                    :value="selectedUnit.product.code"
                  />
                  <input
                    type="hidden"
                    name="torre"
                    :value="selectedUnit.block.code"
                  />
                  <input
                    type="hidden"
                    name="unidade"
                    :value="selectedUnit.unit.code"
                  />
                  <a
                    class="warning__message-link"
                    @click="
                      previewFile({ message, messageLink, linkPath }, 'owner')
                    "
                    href="javascript:ownerDocument.submit()"
                    >{{ messageLink }}</a
                  >
                </form>
              </template>
            </Warning>
            <v-card-actions v-if="!showTechnicalAssistanceServiceActions">
              <v-btn
                :dark="!loadingApp"
                :disabled="loadingApp"
                class="support--background btn-md"
                type="submit"
              >
                <v-progress-circular
                  color="white"
                  indeterminate
                  v-if="loadingApp"
                ></v-progress-circular>
                <span v-else>{{ $t('actions.send') }}</span>
              </v-btn>
            </v-card-actions>
            <span class="ticket__change-steps-error">{{ stepError }}</span>
            <v-card-actions
              class="ticket__change--steps-box"
              v-if="
                showTechnicalAssistanceServiceActions &&
                technicalAssistanceStep !== TECHNICAL_ASSISTANCE_STEPS.CONCLUDED
              "
            >
              <v-btn
                v-on:click="prevStep"
                v-if="
                  technicalAssistanceStep ===
                    TECHNICAL_ASSISTANCE_STEPS.SCHEDULE ||
                  technicalAssistanceStep ===
                    TECHNICAL_ASSISTANCE_STEPS.CONCLUDED
                "
                :dark="!loadingApp"
                :disabled="loadingApp"
                class="support--background btn-md"
              >
                <v-progress-circular
                  color="white"
                  indeterminate
                  v-if="loadingApp"
                ></v-progress-circular>
                <span v-else>{{ $t('actions.goBack') }}</span>
              </v-btn>
              <v-btn
                v-on:click="nextStep"
                v-if="
                  technicalAssistanceStep === TECHNICAL_ASSISTANCE_STEPS.FORM
                "
                :dark="!loadingApp"
                :disabled="loadingApp"
                class="support--background btn-md"
              >
                <v-progress-circular
                  color="white"
                  indeterminate
                  v-if="loadingApp"
                ></v-progress-circular>
                <span v-else>{{ $t('actions.goNext') }}</span>
              </v-btn>
              <v-btn
                v-on:click="sendToKitfix"
                v-if="
                  technicalAssistanceStep ===
                  TECHNICAL_ASSISTANCE_STEPS.SCHEDULE
                "
                :dark="!loadingApp"
                :disabled="loadingApp"
                class="support--background btn-md"
                color="success"
              >
                <v-progress-circular
                  color="white"
                  indeterminate
                  v-if="loadingApp"
                ></v-progress-circular>
                <span v-else>{{ $t('actions.confirm') }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
        <v-layout column align-start justify-center v-else class="pt-4 pl-1">
          <p class="text-sm-center" style="color: var(--label-color)">
            {{ $t('responses.ticketFormSuccess', { newTicketNumber }) }}
          </p>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 lg4 class="mt-4 mb-4">
        <faq-card
          :items="faqItems"
          :loading="faqLoading"
          :error="faqError"
          :params="faqCardParams"
          :errorText="$t('responses.error')"
          @faqSelected="goToFaq"
          :retryFunction="getFaqs"
        ></faq-card>
      </v-flex>
    </v-layout>
    <div>
      <ScreenLoading v-if="loading" />
    </div>
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import {
  APP,
  USER,
  TICKET_CRM,
  CONFIG,
  UNIT,
  DOCS,
  EVENTS,
  ROLES,
} from '../../../utils/constants';
import { getToken } from '@/services/auth';
import faqMixin from '@/mixins/modules/faq';
import supportMixin from '@/mixins/modules/support';
import profile from '@/mixins/modules/profile';
import upload from '@/services/upload';
import logTrace from '@/services/logTrace';
import moment from 'moment-timezone';
import ModulePage from '@/components/layout/Page';
import FilePreview from '@/components/layout/FilePreview';
import FaqCard from '@/components/modules/FaqCard';
import SelectField from '@/components/fields/Select';
import FileInput from '@/components/fields/FileInput';
import TextArea from '@/components/fields/TextArea';
import SelectMultiple from '@/components/fields/SelectMultiple';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import getCurrentBandwidth from '@/utils/bandwidth';
import Modal from '@/components/shared/Modal';
import TechnicalAssistance from './technicalAssistance/TechnicalAssistanceSteps';
import Warning from '@/components/Warning';
import {
  hasPermission,
  hasPermittedRole,
  contractIsActive,
} from '../../../utils';

export default {
  name: 'ticketForm',
  mixins: [faqMixin, supportMixin],
  components: {
    ModulePage,
    FaqCard,
    SelectField,
    SelectMultiple,
    TextArea,
    ScreenLoading,
    FileInput,
    FilePreview,
    Modal,
    TechnicalAssistance,
    ScreenLoading,
    Warning,
  },
  computed: {
    showTechnicalAssistanceServiceActions() {
      return !!(
        this.technicalAssistanceServiceUrl && this.isTechnicalAssistanceSelected
      );
    },
    isTechnicalAssistanceSelected() {
      return this.selectedSummary.value === 'technicalAssistanceErp';
    },
    reasonTicket() {
      const now = new Date().toISOString();
      let scheduledEvents =
        this.$store.getters[EVENTS.GET_TECHNICAL_ASSISTANCE] || [];
      return scheduledEvents.filter((schedule) => schedule.date > now);
    },
    previousReasons() {
      return this.$store.getters[EVENTS.GET_TECHNICAL_ASSISTANCE] &&
        this.$store.getters[EVENTS.GET_TECHNICAL_ASSISTANCE].length > 0
        ? this.$store.getters[EVENTS.GET_TECHNICAL_ASSISTANCE][0].reasons
        : [];
    },
    showWarrantyWarning() {
      return (
        this.technicalAssistanceStep === this.TECHNICAL_ASSISTANCE_STEPS.FORM &&
        this.showTechnicalAssistanceServiceActions &&
        this.showReasonWarrantyWarning
      );
    },
    showReasonWarrantyWarning() {
      return this.selectedReasons.some(
        (reason) =>
          reason.hasExpiredReasons &&
          (!reason.subReasons || reason.subReasons.length == 0)
      );
    },
    technicalAssistanceTerms() {
      var technicalAssistanceTerm = this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? 'technicalAssistanceTermsSyndic'
        : 'technicalAssistanceTerms';
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts[
        technicalAssistanceTerm
      ];
    },
    customBreadcrumbs() {
      const path = this.$route.path;
      const tab = this.pageParams.tabs.find((tab) => tab.value == path);
      if (tab) {
        const title = tab.title.mobile
          ? this.mobile
            ? tab.title.mobile
            : tab.title.notMobile
          : tab.title;
        return [{ text: title }];
      } else {
        return [{ text: this.$t('pages.support.breadcrumb') }];
      }
    },
    isKeyDelivered() {
      if (this.isClient) {
        return !!this.$store.getters[UNIT.GET_IS_KEY_DELIVERED];
      } else {
        return true;
      }
    },
    ticketSubjects() {
      const isIndirect = this.$store.getters[UNIT.GET_IS_INDIRECT];

      const hasKeyDelivered = this.isKeyDelivered;

      const hasCertificateDate =
        !!this.$store.getters[UNIT.GET_CONCLUSION_CERTIFICATE_DATE];
      const hasValidSchedules =
        this.technicalDate.filter((item) => item.available).length !== 0 ||
        !!this.reasonTicket.length;

      const canShowTechnicalAssistanceService =
        hasValidSchedules && hasCertificateDate;
      const canShowTechnicalAssistance =
        hasKeyDelivered &&
        (this.technicalAssistanceServiceUrl
          ? canShowTechnicalAssistanceService
          : true);
      return this.$store.getters[CONFIG.GET].navigationRules.ticketSubjects
        .filter((subject) => {
          const permittedRoleRule = subject.roles
            ? hasPermittedRole(subject.roles)
            : true;
          const adminProfilesRule = subject.adminProfiles
            ? hasPermission(subject.adminProfiles, false)
            : true;
          const showToIndirectRule =
            subject.showToIndirect != null && isIndirect === true
              ? subject.showToIndirect
              : true;
          const isTechnicalAssistanceEnabled =
            subject.value === 'technicalAssistanceErp'
              ? canShowTechnicalAssistance
              : true;

          return (
            permittedRoleRule &&
            adminProfilesRule &&
            showToIndirectRule &&
            isTechnicalAssistanceEnabled
          );
        })
        .map((subject) => {
          const translationKey = `pages.support.subject.${subject.value}`;
          const subjectTranslation = this.$t(translationKey);
          return {
            ...subject,
            text:
              subjectTranslation != translationKey
                ? subjectTranslation
                : subject.text,
          };
        });
    },
    getResponsibleManualLabel() {
      return this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? this.$t('pages.support.goToSyndicManual')
        : this.$t('pages.support.goToOwnerManual');
    },
    technicalAssistanceServiceUrl() {
      return this.$store.getters[CONFIG.GET_KITFIX_URL];
    },
  },
  data() {
    return {
      selectedSummary: null,
      model: {
        summary: '',
        public: {
          content: '',
          attachments: [],
        },
      },
      productsStates: {},
      files: [],
      newTicketNumber: 0,
      fileError: '',
      formValid: false,
      maxFileSize: enums.maxUploadFileSize,
      pageParams: this.$store.getters[APP.PAGES].support,
      faqCardParams: this.$store.getters[APP.APP_MODULES].faq,
      useTicketProductState: false,
      reasons: [],
      selectedReasons: [
        { reason: null, subReasons: null, hasExpiredReasons: false },
      ],
      scheduleStep: {
        schedule: undefined,
        companion: undefined,
        accompanied: undefined,
      },
      stepError: '',
      loading: false,
      loadingTechnicalAssistanceSubject: false,
      loadingLabel: this.$t('labels.loading'),
      concluded: undefined,
      documentResponsible: undefined,
      technicalSchedule: [],
      technicalDate: [],
      technicalAssistanceStep: 0,
      TECHNICAL_ASSISTANCE_STEPS: {
        FORM: 0,
        SCHEDULE: 1,
        CONCLUDED: 2,
      },
    };
  },
  created() {
    bus.$on('unit:change', this.init);
    bus.$on('unit:update', this.init);
    this.init();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.init);
    bus.$off('unit:update', this.init);
  },
  methods: {
    init() {
      this.useTicketProductState =
        this.$store.getters[CONFIG.GET].navigationRules.useTicketProductState;
      this.selectedSummary = this.ticketSubjects[0];
      this.$store.dispatch(EVENTS.FETCH_TECHNICAL_ASSISTANCE);
      this.getFaqs();
      this.getDocs();
      this.getReasons();
      this.getTechnicalDates();
    },
    getSelectedReasons(newSelectedReasons) {
      this.selectedReasons = [...newSelectedReasons];
    },
    verifySolicitationStep() {
      const subReasons = this.selectedReasons.filter(
        (item) => !!item.subReasons
      );
      let hasAtLeastOneSubReason = false;

      if (!!subReasons.length) {
        hasAtLeastOneSubReason = subReasons.filter(
          (item) => !!item.subReasons.length
        );
        hasAtLeastOneSubReason = !!hasAtLeastOneSubReason.length;
      }

      return (
        !!this.selectedReasons.length &&
        !!subReasons.length &&
        hasAtLeastOneSubReason &&
        this.model.public.content != ''
      );
    },
    setSchedule(val) {
      this.scheduleStep = val;
    },
    cleanStepError() {
      this.stepError = '';
    },
    nextStep() {
      if (this.verifySolicitationStep()) {
        this.technicalAssistanceStep++;
        this.cleanStepError();
      } else {
        this.stepError = this.$t('responses.requiredFieldsError');
        this.formValid = false;
      }
    },
    prevStep() {
      this.technicalAssistanceStep--;
    },
    async sendToKitfix() {
      //? Adding an existent ticket
      if (this.reasonTicket && !!this.reasonTicket.length) {
        await this.sendAddReasons();
      } else {
        await this.sendScheduleRequest();
      }
    },
    async sendAddReasons() {
      let idTicket = this.reasonTicket[0].ticketId;
      const ticketNumber = this.reasonTicket[0].ticketNumber;
      const ticketContent = await this.getTechnicalAssistanceTicketContent(
        ticketNumber
      );
      if (ticketContent) {
        let response = await this.sendTechnicalAssistance(ticketContent);
        if (response) {
          this.technicalAssistanceStep++;
          return;
        }
      }
      bus.$emit('snackbar:open', {
        text: this.$t('responses.error'),
        color: enums.snackbarColors.error,
      });
    },
    async sendScheduleRequest() {
      this.loading = true;
      try {
        if (this.isValidSchedule()) {
          const createResult = await this.createSchedule();
          if (createResult) {
            this.technicalAssistanceStep++;
          }
        } else {
          this.stepError = this.$t('responses.requiredFieldsError');
          this.formValid = false;
        }
      } finally {
        this.loading = false;
      }
    },
    isValidSchedule() {
      return (
        !!this.scheduleStep.schedule &&
        !!this.scheduleStep.accompanied &&
        this.isCompanionDataComplete(
          this.scheduleStep.accompanied,
          this.scheduleStep.companion
        )
      );
    },
    isCompanionDataComplete(companyType, companionData) {
      if (companyType === 'my') {
        return true;
      } else if (!!companionData.name && !!companionData.document) {
        return true;
      } else {
        return false;
      }
    },
    async createSchedule() {
      const result = await this.getTechnicalAssistanceTicketContent();
      this.stepError = '';
      if (result) {
        return await this.sendTechnicalAssistance(result);
      } else {
        return false;
      }
    },
    async sendTechnicalAssistance(ticketPayload) {
      let response = null;
      let payload;
      try {
        let url = `${this.technicalAssistanceServiceUrl}/api/workOrder/createWorkOrders`;
        payload = await this.technicalAssistanceParser(ticketPayload);
        response = await this.requestService(url, 'POST', { data: payload });
        this.$store.commit(EVENTS.RESET_TECHNICAL_ASSISTANCE_CACHE);
      } catch (error) {
        console.error(error);
        bus.$emit('snackbar:open', {
          text: this.$t('responses.technicalAssistanceError'),
          color: enums.snackbarColors.error,
        });

        return false;
      }
      if (response) {
        this.concluded = payload;
        if (response.length > 0) {
          // TODO: Add sms to Syndic
          const ticketResponse = response[0];
          const ticketNumber = ticketResponse.ticketNumber;
          if (this.isClient) {
            const contractId =
              this.selectedUnit.contracts.find(contractIsActive).id;
            let smsUrl = `${process.env.SMS_API}/addToQueue`;
            const smsData = {
              contractId,
              productId: this.selectedUnit.product.id,
              blockCode: this.selectedUnit.block.code,
              unitCode: this.selectedUnit.unit.code,
              smsType: 'technicalAssistanceScheduled',
              ticketNumber: ticketNumber,
              ticketCrmToken: this.$store.getters[TICKET_CRM.GET_TOKEN],
            };
            this.requestService(smsUrl, 'POST', { data: smsData });
          }
          //? Ticket Creation
          if (this.scheduleStep.schedule) {
            this.createTrace(
              this.enums.logTraceActions.technicalAssistanceSchedule,
              this.getScheduleLogTraceDetails(ticketResponse)
            );
          }
          //? Ticket Interaction
          else {
            let { content, attachments } = this.model.public;
            const traceData = {
              content,
              summary: `${this.selectedSummary.text}`,
              number: ticketNumber,
              attachments,
            };
            this.createTrace(
              enums.logTraceActions.ticketInteraction,
              this.getScheduleLogTraceDetails(ticketResponse)
            );
          }
          return true;
        }
      }
      return false;
    },
    getScheduleLogTraceDetails(ticketResponse) {
      let reasonDetails = this.selectedReasons.map((selectedReason) => {
        let reason = this.reasons.find((reason) => {
          return reason.id === selectedReason.reason;
        });
        return {
          reasonName: reason.name,
          ...selectedReason,
        };
      });

      return {
        number: ticketResponse.ticketNumber,
        scheduleDate: ticketResponse.scheduleDate,
        reasons: reasonDetails,
        isCompanion: !!ticketResponse.companionName,
        companionName: ticketResponse.companionName,
        companionDocument: ticketResponse.companionDocument,
        termsAgreed: true,
      };
    },
    mountReasons() {
      return this.selectedReasons.map((item) => {
        let selectedReason = this.reasons.find(
          (reason) => reason.id === item.reason
        );
        let selectedSubReasons = item.subReasons.map((subReason) => {
          return {
            id: subReason.value,
            name: subReason.text,
          };
        });
        return {
          id: selectedReason.id,
          name: selectedReason.name,
          subReasons: selectedSubReasons,
        };
      });
    },
    async technicalAssistanceParser(ticketPayload) {
      //? Has already a created ticket
      if (this.reasonTicket && this.reasonTicket.length > 0) {
        return {
          idTicket: this.reasonTicket[0].ticketId,
          ticketNumber: this.reasonTicket[0].ticketNumber,
          idSchedule: this.reasonTicket[0].scheduleId,
          ticketPayload: ticketPayload,
          reasons: this.mountReasons(),
          ticketCrmToken: this.$store.getters[TICKET_CRM.GET_TOKEN],
          portalToken: getToken(),
          productSku: this.selectedUnit.sku,
          tenantId: this.$store.getters[CONFIG.GET].tenantId,
          portalTicketCrmUrl: process.env.TICKET_CRM_API_URL,
        };
      } else {
        let customerId = -1;
        let email = this.user.email;
        if (this.user.userRole === ROLES.CLIENT_ROLE) {
          let imobmeData = this.$store.getters[USER.GET_IMOBME_DATA];
          if (!imobmeData) {
            await this.getUser();
            imobmeData = this.$store.getters[USER.GET_IMOBME_DATA];
          }
          customerId = imobmeData.id;
        }
        const { schedule, companion, accompanied } = this.scheduleStep;
        return {
          idClientUser: this.user.username,
          scheduleDate: this.toDefaultTimezone(
            schedule.startDateLocalTime
          ).toISOString(),
          dueDate: this.toDefaultTimezone(
            schedule.endDateLocalTime
          ).toISOString(),
          cellphone: this.$store.getters[USER.GET_CELLPHONE_STRING],
          estimateTime: schedule.serviceTime,
          idTechnical: schedule.technicalId,
          technicalName: schedule.technicalName,
          idSchedule: schedule.id,
          isCompanion: accompanied === 'other',
          companionName: companion ? companion.name : '',
          companionDocument: companion ? companion.document : '',
          schedule: schedule,
          ticketPayload: ticketPayload,
          reasons: this.mountReasons(),
          ticketCrmToken: this.$store.getters[TICKET_CRM.GET_TOKEN],
          portalToken: getToken(),
          productSku: this.selectedUnit.sku,
          tenantId: this.$store.getters[CONFIG.GET].tenantId,
          portalTicketCrmUrl: process.env.TICKET_CRM_API_URL,
          customerId,
          email,
        };
      }
    },
    async getTechnicalAssistanceTicketContent(ticketNumber) {
      try {
        if (!this.$refs.supportForm.validate()) return;
        const { product } = this.selectedUnit;
        let productState;
        if (this.useTicketProductState) {
          if (!this.productsStates[product.id]) {
            this.productsStates[product.id] =
              await this.getProductLocationState(product);
          }
          productState = this.productsStates[product.id];
          if (!productState) return;
        }

        let { content, attachments } = this.model.public;
        let contentMessage = content;
        content += this.getScheduledText(ticketNumber);
        if (this.files.length > 0) {
          attachments = attachments = await this.saveFiles();
        }

        let result;
        if (!ticketNumber) {
          const payload = {
            summary: `${this.selectedSummary.text}`,
            comments: {
              public: { content, attachments },
            },
            productState,
          };
          result = payload;
        } else {
          const payload = {
            comments: {
              public: { content, attachments },
            },
          };
          result = payload;
        }
        return result;
      } catch (err) {
        const bandwidthInMbps = await getCurrentBandwidth();
        this.createTrace(enums.logTraceActions.newTicketError, {
          summary: this.selectedSummary.text,
          content: this.model.public,
          files: this.files.map((file) => ({
            name: file.binary.name,
            size: file.binary.size,
            type: file.binary.type,
          })),
          error: {
            data: err.data,
            stack: err.stack,
          },
          connectionSpeed: `${bandwidthInMbps} MB`,
        });

        let translatedMessage = this.$t('responses.error');

        if (err.data.message === 'Product not linked to this client') {
          translatedMessage = this.$t('responses.octadeskProductNotLinked');
        }

        bus.$emit('snackbar:open', {
          text: translatedMessage,
          color: enums.snackbarColors.error,
        });
      }
    },
    getScheduledText(ticketNumber) {
      let scheduleDate;
      let companionText = '';
      if (ticketNumber) {
        const reasonTicket = this.reasonTicket[0];
        scheduleDate = this.formatLongDateTime(reasonTicket.date);
      } else if (this.scheduleStep) {
        const { schedule, companion, accompanied } = this.scheduleStep;
        scheduleDate = this.formatLongDateTime(schedule.startDate);
        companionText =
          companion && companion.name
            ? `
              ${this.$t('pages.support.technicalAssistance.accompaniedBy')}:\n
              ${companion.name} - ${companion.document}`
            : '';
      }
      const selectedUnit = this.$store.getters[UNIT.GET_SELECTED];
      const address = this.$store.getters[UNIT.GET_SELECTED_PRODUCT].address;

      let itemsText = '';
      for (const { reason: reasonId, subReasons } of this.selectedReasons) {
        const reason = this.reasons.find((r) => r.id == reasonId);
        const reasonName = reason.name;
        for (const subReason of subReasons) {
          itemsText += `${reasonName} - ${subReason.text}\n`;
        }
      }
      const dateText = scheduleDate
        ? `
            ${this.$t('labels.datetime')}:\n
            ${scheduleDate}\n`
        : '';

      let message = `\n
          .\n
          .\n
          .\n
          ${dateText}
          ${this.$t('pages.support.technicalAssistance.reasonItems')}:\n
          ${itemsText}\n
          ${this.$t('pages.support.technicalAssistance.address')}:\n
          ${selectedUnit.product.title} - ${selectedUnit.block.title} - ${
        selectedUnit.unit.code
      }\n
          ${address.street}, ${address.number} - ${address.neighborhood}, ${
        address.city
      } - ${address.uf}\n
          ${companionText}\n`;

      const config = this.$store.getters[CONFIG.GET];

      if (config && config.texts && config.texts.ticketCreationNotice) {
        message += `Aviso:\n${config.texts.ticketCreationNotice}\n`;
      }

      return message;
    },
    mountAddress() {
      this.address = this.$store.getters[UNIT.GET_SELECTED_PRODUCT].address;
      this.address.product = this.selectedUnit.product.title;
      this.address.block = this.selectedUnit.block.title;
    },
    handleFileToLarge() {
      this.fileError = this.$t('responses.filesToLarge');
    },
    handleFileInvalid(file) {
      this.fileError = this.$t('responses.fileInvalid', { file });
    },
    goToTab(path) {
      if (path != this.$route.path) {
        this.$router.push(path);
      } else {
        this.resetModel();
      }
    },
    updateFiles(v) {
      this.fileError = '';
      if (v) this.files.push(...v);
    },
    removeFile(v) {
      this.fileError = '';
      this.files.splice(this.files.indexOf(v), 1);
    },
    async getProductLocationState({ code, id }) {
      const params = {
        filter: { code, externalSourceId: id },
        desiredFields: { code: 1, address: 1 },
      };
      const url = `${process.env.CRUD_API_GET}/product`;
      const result = await this.requestService(url, 'GET', { params });
      const [item] = result.items;

      if (!item || !item.address) {
        throw new Error(
          `This product does not exist on database. PRODUCT_CODE: ${code}`
        );
      }

      return item.address.uf;
    },
    saveFiles() {
      const files = this.files.map((o) => o.binary);
      return upload(files, enums.fileCategory.TICKET_ATTACHMENT);
    },
    async submit() {
      let attachmentsUrls = [];
      try {
        if (!this.$refs.supportForm.validate()) return;
        const { product } = this.selectedUnit;
        let productState;
        if (this.useTicketProductState) {
          if (!this.productsStates[product.id]) {
            this.productsStates[product.id] =
              await this.getProductLocationState(product);
          }
          productState = this.productsStates[product.id];
          if (!productState) return;
        }

        let { content, attachments } = this.model.public;
        if (this.files.length > 0) {
          attachmentsUrls = attachments = await this.saveFiles();
        }
        const payload = {
          summary: `${this.selectedSummary.text}`,
          subject: this.selectedSummary,
          comments: {
            public: { content, attachments },
          },
          productState,
        };
        const result = await this.sendTicket(payload, true);
        if (result) {
          this.newTicketNumber = result.number;
          this.$store.commit(TICKET_CRM.NEW_TICKET_CREATED);
          this.createTrace(enums.logTraceActions.newTicket, {
            number: result.number,
            summary: result.summary,
            description: result.descriptionByText,
          });
        }
      } catch (err) {
        const bandwidthInMbps = await getCurrentBandwidth();
        this.createTrace(enums.logTraceActions.newTicketError, {
          summary: this.selectedSummary.text,
          attachmentsUrls,
          content: this.model.public,
          files: this.files.map((file) => ({
            name: file.binary.name,
            size: file.binary.size,
            type: file.binary.type,
          })),
          error: {
            data: err.data,
            stack: err.stack,
          },
          connectionSpeed: `${bandwidthInMbps} MB`,
        });
        console.warn({ err });

        let translatedMessage = this.$t('responses.error');

        if (err.data.message === 'Product not linked to this client') {
          translatedMessage = this.$t('responses.octadeskProductNotLinked');
        }

        bus.$emit('snackbar:open', {
          text: translatedMessage,
          color: enums.snackbarColors.error,
        });
      }
    },
    resetModel() {
      this.selectedSummary = null;
      this.model.public = { content: '', attachments: [] };
      this.productsStates = {};
      this.files = [];
      this.newTicketNumber = 0;
      this.fileError = '';
      this.formValid = true;
      this.useTicketProductState = false;
      this.selectedReasons = [
        { reason: null, subReasons: null, hasExpiredReasons: false },
      ];
      this.scheduleStep = {
        schedule: undefined,
        companion: undefined,
        accompanied: undefined,
      };
      this.technicalAssistanceStep = this.TECHNICAL_ASSISTANCE_STEPS.FORM;
      this.stepError = '';
      this.loading = false;
      this.concluded = undefined;
      this.$store.commit(EVENTS.RESET_TECHNICAL_ASSISTANCE_CACHE);

      this.init();
    },

    async getPerformanceStandard() {
      try {
        let productDetails =
          this.$store.getters[UNIT.GET_SELECTED_PRODUCT_DETAILS];
        if (productDetails.isPerformanceStandard == null) {
          productDetails = await this.$store.dispatch(
            UNIT.FETCH_PRODUCT_DETAILS
          );
        }
        return productDetails && !!productDetails.isPerformanceStandard;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
    async getReasons() {
      if (!this.technicalAssistanceServiceUrl) {
        return;
      }
      let isPerformanceStandard = await this.getPerformanceStandard();
      let conclusionCertificateDate =
        this.$store.getters[UNIT.GET_CONCLUSION_CERTIFICATE_DATE];

      if (this.isKeyDelivered) {
        if (conclusionCertificateDate != null) {
          let url = `${this.technicalAssistanceServiceUrl}/api/technicalAssistance/getAllReasons`;
          let params = {
            conclusionCertificateDate,
            isPerformanceStandard,
          };
          const response = await this.requestService(url, 'GET', { params });
          this.reasons = response.filter((reason) => reason.proceeds);
        }
      }
    },
    async getTechnicalDates() {
      try {
        let productId = this.selectedUnit.product.id;
        let blockCode = this.selectedUnit.block.code;

        if (!this.technicalAssistanceServiceUrl) {
          return;
        }
        this.loadingTechnicalAssistanceSubject = true;
        let url = `${this.technicalAssistanceServiceUrl}/api/schedule/getSchedulesByProduct`;
        const params = {
          productId,
          productBlockCode: blockCode,
        };
        let response = await this.requestService(url, 'GET', { params });
        this.technicalSchedule = response;
        this.technicalDate = response.map((item) => {
          let [localDate, localHour] = item.startDateLocalTime.split('T');
          return {
            value: item.id,
            date: localDate,
            hour: localHour,
            available: !item.isScheduled,
          };
        });
      } catch (error) {
        console.log('getTechnicalDates');
      } finally {
        this.loadingTechnicalAssistanceSubject = false;
      }
    },
    getDocs() {
      let docs = this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? this.$store.getters[DOCS.GET_SYNDIC_DOCS]
        : this.$store.getters[DOCS.GET_OWNER_DOCS];

      if (!!docs.length) this.documentResponsible = docs[0];
    },
    previewFile({ message, messageLink, linkPath }, type) {
      const action = this.enums.logTraceActions[`${type}DocsDownload`];
      this.createTrace(action, { title: message, attachment: linkPath });
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket {
  &__input {
    border: 1px lightgray solid;
    border-radius: 5px;
    padding: 0px 0px 5px;
    &__error {
      border: 1px #ff5252 solid;
    }

    >>> .v-input__slot {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.02),
        0 1px 5px 0 rgba(0, 0, 0, 0.02) !important;

      textarea {
        margin: 0 !important;
      }
    }
  }

  &__change-steps-error {
    color: red;
    display: flex;
    margin: 1rem;
  }
}
.select-field2 {
  margin-top: 22px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  position: relative;

  &__no-data {
    padding: 7px;
    font-size: 14px;
    color: var(--field-font-color);
  }

  &__loading {
    >>> .v-progress-linear__background {
      background-color: var(--brand-color) !important;
      border-color: var(--brand-color) !important;
    }

    >>> .v-progress-linear__bar__indeterminate {
      background-color: var(--brand-color) !important;
      border-color: var(--brand-color) !important;
    }
  }

  >>> .v-input__slot {
    min-height: 26px;
    border: 1px solid #dcdcdc !important;
    min-height: 30px;
    height: 32.5px !important;
    border-radius: 5px;
    &:hover {
      border: 1px solid #dcdcdc !important;
    }
  }

  >>> .v-input__append-inner {
    margin-top: 4px !important;
  }

  >>> .v-select__slot {
    height: 30px;
  }

  >>> .v-label {
    position: absolute !important;
    top: -22px;
    left: -12px !important;
    color: #999999;
    transform: initial !important;
  }

  >>> .v-text-field--outline .v-label--active {
    transform: initial !important;
    padding-top: 0px !important;
  }

  >>> .v-select__selections {
    // color: var(--field-font-color);
    padding-top: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/support/ticket/TicketForm.vue